// extracted by mini-css-extract-plugin
export default {"stepper":"Stepper_stepper__3ES5C","stepNumber":"Stepper_stepNumber__6bivu","stepLabel":"Stepper_stepLabel__dZpkY","active":"Stepper_active__AqE6Q"};